import { makeStyles } from "@material-ui/core";

export const useLoggedDevicesStyles = makeStyles(() => ({
    infoItemWrapper: {
        "& .MuiTypography-h6": {
            fontWeight: 700
        }
    }
}));
